import { gql } from 'apollo-angular';

export const GET_USER_INFO = gql`
  query Me {
    me {
      addresses {
        id
        firstName
        lastName
        companyName
        streetAddress1
        streetAddress2
        city
        cityArea
        postalCode
        country {
          code
          country
        }
        countryArea
        phone
        isDefaultShippingAddress
        isDefaultBillingAddress
      }
      email
      firstName
    }
  }
`;

export const GET_CAR_LIST_BY_HEADER = gql`
  query GetCarListByHeader($first: Int) {
    productTypes(first: $first) {
      edges {
        node {
          id
          slug
          name
          productAttributes {
            id
            name
            slug
            choices(first: $first) {
              edges {
                node {
                  id
                  slug
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const CURRENCY_PRODUCT_LIST_ALL = gql`
  query CurrencyProductListAll($currency: Currency!, $first: Int) {
    marketplaceProducts(currency: $currency, first: $first) {
      edges {
        node {
          id
          name
          slug
          channel
          variants {
            id
          }

          pricing {
            priceRange {
              start {
                gross {
                  amount
                  currency
                }
              }
              stop {
                gross {
                  amount
                  currency
                }
              }
            }
          }
          category {
            id
            name
          }
          thumbnail(size: 1024, format: WEBP) {
            url
            alt
          }
        }
      }
    }
  }
`;

export const SEARCH_PRODUCT_LIST = gql`
  query MarketplaceProducts($currency: Currency!, $carSlug: String) {
    marketplaceProducts(currency: $currency, carSlug: $carSlug, first: 100) {
      edges {
        node {
          id
          name
          slug
          channel
          variants {
            id
          }

          pricing {
            priceRange {
              start {
                gross {
                  amount
                  currency
                }
              }
              stop {
                gross {
                  amount
                  currency
                }
              }
            }
          }
          category {
            id
            name
          }
          thumbnail(size: 1024, format: WEBP) {
            url
            alt
          }
        }
      }
    }
  }
`;

export const GET_CATEGORIES = gql`
  query Categories($first: Int) {
    categories(first: $first) {
      totalCount
      edges {
        cursor
        node {
          id
          name
          slug
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_PRODUCT_BY_SLUG = gql`
  query Product($slug: String, $channel: String) {
    product(slug: $slug, channel: $channel) {
      id
      name
      slug
      description
      productVariants(first: 10) {
        edges {
          node {
            id
          }
        }
      }
      channel
      pricing {
        priceRange {
          start {
            gross {
              amount
              currency
            }
          }
          stop {
            gross {
              amount
              currency
            }
          }
        }
      }
      category {
        id
        name
      }
      thumbnail(size: 1024, format: WEBP) {
        url
        alt
      }
    }
  }
`;

export const CREATE_ACCOUNT_ADDRESS = gql`
  mutation AccountAddressCreate($input: AddressInput!) {
    accountAddressCreate(input: $input) {
      address {
        id
        firstName
        lastName
        companyName
        streetAddress1
        streetAddress2
        city
        cityArea
        postalCode
        country {
          country
          code
        }
        countryArea
        phone
        isDefaultShippingAddress
        isDefaultBillingAddress
      }
    }
  }
`;

export const GET_MARKETPLACE_CART_USER = gql`
  query MarketplaceCart {
    marketplaceCart {
      channels {
        name
        slug
        id
        currencyCode
        totalPrice {
          amount
          currency
        }
        shippingPrice {
          amount
          currency
        }
        isActive
        lines {
          id
          quantity
          variant {
            id
            pricing {
              price {
                currency
                gross {
                  amount
                  currency
                }
                net {
                  amount
                  currency
                }
                tax {
                  amount
                  currency
                }
              }
            }
            media {
              url
              id
              alt
            }
            name
            product {
              name
              id
              media {
                url
                alt
              }
              description
              slug
              thumbnail(size: 720) {
                alt
                url
              }
            }
          }
        }
      }
      id
      updatedAt
      createdAt
    }
  }
`;

export const GET_MARKETPLACE_CART_GUSET = gql`
  query MarketplaceCart($marketplaceCartId: ID) {
    marketplaceCart(id: $marketplaceCartId) {
      channels {
        name
        slug
        id
        currencyCode
        totalPrice {
          amount
          currency
        }
        shippingPrice {
          amount
          currency
        }
        isActive
        lines {
          id
          quantity
          variant {
            id
            pricing {
              price {
                currency
                gross {
                  amount
                  currency
                }
                net {
                  amount
                  currency
                }
                tax {
                  amount
                  currency
                }
              }
            }
            media {
              url
              id
              alt
            }
            name
            product {
              name
              id
              media {
                url
                alt
              }
              description
              slug
              thumbnail(size: 720) {
                alt
                url
              }
            }
          }
        }
      }
      id
      updatedAt
      createdAt
    }
  }
`;

export const CREATE_MARKETPLACE_CART = gql`
  mutation MarketplaceCartCreate {
    marketplaceCartCreate {
      marketplaceCart {
        channels {
          name
          slug
          id
          currencyCode
          totalPrice {
            amount
            currency
          }
          shippingPrice {
            amount
            currency
          }
          isActive
          lines {
            id
            quantity
            variant {
              id
              pricing {
                price {
                  currency
                  gross {
                    amount
                    currency
                  }
                  net {
                    amount
                    currency
                  }
                  tax {
                    amount
                    currency
                  }
                }
              }
              media {
                url
                id
                alt
              }
              name
              product {
                name
                id
                media {
                  url
                  alt
                }
                description
                slug
                thumbnail(size: 720) {
                  alt
                  url
                }
              }
            }
          }
        }
        id
        updatedAt
        createdAt
      }
    }
  }
`;

export const ADD_CART = gql`
  mutation MarketplaceCartAdd($marketplaceCartAddId: ID!, $input: MarketplaceCartLineAddInput!) {
    marketplaceCartLineAdd(id: $marketplaceCartAddId, input: $input) {
      marketplaceCart {
        channels {
          name
          slug
          id
          currencyCode
          totalPrice {
            amount
            currency
          }
          shippingPrice {
            amount
            currency
          }
          isActive
          lines {
            id
            quantity
            variant {
              id
              pricing {
                price {
                  currency
                  gross {
                    amount
                    currency
                  }
                  net {
                    amount
                    currency
                  }
                  tax {
                    amount
                    currency
                  }
                }
              }
              media {
                url
                id
                alt
              }
              name
              product {
                name
                id
                media {
                  url
                  alt
                }
                description
                slug
                thumbnail(size: 720) {
                  alt
                  url
                }
              }
            }
          }
        }
        id
        updatedAt
        createdAt
      }
    }
  }
`;

export const DELETE_CART = gql`
  mutation MarketplaceCartDelete($marketplaceCartLineDeleteId: ID!) {
    marketplaceCartLineDelete(id: $marketplaceCartLineDeleteId) {
      marketplaceCart {
        channels {
          name
          slug
          id
          currencyCode
          totalPrice {
            amount
            currency
          }
          shippingPrice {
            amount
            currency
          }
          isActive
          lines {
            id
            quantity
            variant {
              id
              pricing {
                price {
                  currency
                  gross {
                    amount
                    currency
                  }
                  net {
                    amount
                    currency
                  }
                  tax {
                    amount
                    currency
                  }
                }
              }
              media {
                url
                id
                alt
              }
              name
              product {
                name
                id
                media {
                  url
                  alt
                }
                description
                slug
                thumbnail(size: 720) {
                  alt
                  url
                }
              }
            }
          }
        }
        id
        updatedAt
        createdAt
      }
    }
  }
`;

export const UPDATE_CART = gql`
  mutation MarketplaceCartUpdate(
    $marketplaceCartLineUpdateId: ID!
    $input: MarketplaceCartLineUpdateInput!
  ) {
    marketplaceCartLineUpdate(id: $marketplaceCartLineUpdateId, input: $input) {
      marketplaceCart {
        channels {
          name
          slug
          id
          currencyCode
          totalPrice {
            amount
            currency
          }
          shippingPrice {
            amount
            currency
          }
          isActive
          lines {
            id
            quantity
            variant {
              id
              pricing {
                price {
                  currency
                  gross {
                    amount
                    currency
                  }
                  net {
                    amount
                    currency
                  }
                  tax {
                    amount
                    currency
                  }
                }
              }
              media {
                url
                id
                alt
              }
              name
              product {
                name
                id
                media {
                  url
                  alt
                }
                description
                slug
                thumbnail(size: 720) {
                  alt
                  url
                }
              }
            }
          }
        }
        id
        updatedAt
        createdAt
      }
    }
  }
`;

export const MARKETPLACE_CART_ASSIGN_USER = gql`
  mutation MarketplaceCartAssignUser($id: ID!) {
    marketplaceCartAssignUser(id: $id) {
      marketplaceCart {
        channels {
          name
          slug
          id
          currencyCode
          totalPrice {
            amount
            currency
          }
          shippingPrice {
            amount
            currency
          }
          isActive
          lines {
            id
            quantity
            variant {
              id
              pricing {
                price {
                  currency
                  gross {
                    amount
                    currency
                  }
                  net {
                    amount
                    currency
                  }
                  tax {
                    amount
                    currency
                  }
                }
              }
              media {
                url
                id
                alt
              }
              name
              product {
                name
                id
                media {
                  url
                  alt
                }
                description
                slug
                thumbnail(size: 720) {
                  alt
                  url
                }
              }
            }
          }
        }
        id
        updatedAt
        createdAt
      }
    }
  }
`;

export const CREATE_MARKETPLACE_CHECKOUT = gql`
  mutation MarketplaceCheckoutCreate($cartLineIds: [ID]!) {
    marketplaceCheckoutCreate(cartLineIds: $cartLineIds) {
      marketplaceCheckout {
        id
        orderNumber
        checkouts(first: 100) {
          edges {
            node {
              id
              lines {
                quantity
                totalPrice {
                  gross {
                    currency
                    amount
                  }
                }
                variant {
                  name
                  product {
                    name
                  }
                }
              }
              channel {
                slug
                name
              }
              quantity
            }
          }
        }
      }
    }
  }
`;

export const ADD_MARKETPLACE_CHECKOUT_SHIPPING_ADDRESS = gql`
  mutation MarketplaceCheckoutShippingAddressAdd(
    $orderNumber: String!
    $input: MarketplaceCheckoutShippingAddressAddInput!
  ) {
    marketplaceCheckoutShippingAddressAdd(orderNumber: $orderNumber, input: $input) {
      marketplaceCheckout {
        checkouts(first: 100) {
          edges {
            node {
              totalPrice {
                gross {
                  currency
                  amount
                }
              }
              shippingPrice {
                gross {
                  amount
                  currency
                }
              }
              billingAddress {
                id
                firstName
                lastName
                companyName
                streetAddress1
                streetAddress2
                city
                cityArea
                postalCode
                country {
                  country
                  code
                }
                countryArea
                phone
                isDefaultShippingAddress
                isDefaultBillingAddress
              }
              shippingAddress {
                id
                firstName
                lastName
                companyName
                streetAddress1
                streetAddress2
                city
                cityArea
                postalCode
                country {
                  country
                  code
                }
                countryArea
                phone
                isDefaultShippingAddress
                isDefaultBillingAddress
              }
              token
            }
          }
        }
      }
    }
  }
`;

export const GET_ORDERS = gql`
  query MarketplaceOrders {
    marketplaceOrders {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          createdAt
          id
          info
          number
          updatedAt
          orders(first: 100) {
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
            totalCount
            edges {
              cursor
              node {
                channel {
                  name
                  slug
                  id
                }
                id
                lines {
                  id
                  quantity
                  variant {
                    id
                    pricing {
                      price {
                        currency
                        gross {
                          amount
                          currency
                        }
                        net {
                          amount
                          currency
                        }
                        tax {
                          amount
                          currency
                        }
                      }
                    }
                    media {
                      url
                      id
                      alt
                    }
                    name
                    product {
                      name
                      id
                      media {
                        url
                        alt
                      }
                      description
                      slug
                      thumbnail(size: 720) {
                        alt
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ORDER = gql`
  query MarketplaceOrder($marketplaceOrderId: ID) {
    marketplaceOrder(id: $marketplaceOrderId) {
      createdAt
      id
      info
      number
      updatedAt
      orders(first: 100) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        totalCount
        edges {
          cursor
          node {
            channel {
              name
              slug
              id
            }
            id
            lines {
              id
              quantity
              variant {
                id
                pricing {
                  price {
                    currency
                    gross {
                      amount
                      currency
                    }
                    net {
                      amount
                      currency
                    }
                    tax {
                      amount
                      currency
                    }
                  }
                }
                media {
                  url
                  id
                  alt
                }
                name
                product {
                  name
                  id
                  media {
                    url
                    alt
                  }
                  description
                  slug
                  thumbnail(size: 720) {
                    alt
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const OTP_SEND = gql`
  mutation OtpSend($phoneNumber: String!) {
    otpSend(phoneNumber: $phoneNumber) {
      success
      error
    }
  }
`;

export const OTP_VERIFY = gql`
  mutation OtpVerify($otp: String!, $phoneNumber: String!) {
    otpVerify(otp: $otp, phoneNumber: $phoneNumber) {
      success
      error
    }
  }
`;
